import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CarrierUsersData, IdentityUserData, MyAuthorizedEntities, ServiceResponse, UserAdminData } from '../../shared/models';
import { mapResponse } from '../../shared/operators/map-response';

@Injectable()
export class UserAdminService {
  constructor(private http: HttpClient) {}

  getMyAuthorizedEntities(): Observable<MyAuthorizedEntities> {
    return this.http
      .get<ServiceResponse<MyAuthorizedEntities>>(`${environment.apiUrl}/api/UserAdmin/GetMyAuthorizedEntities`)
      .pipe(mapResponse());
  }

  getUsers(query: string): Observable<UserAdminData[]> {
    return this.http.get<ServiceResponse<UserAdminData[]>>(`${environment.apiUrl}/api/useradmin/?query=${query}`).pipe(mapResponse());
  }

  getAdminUsers(): Observable<UserAdminData[]> {
    return this.http.get<ServiceResponse<UserAdminData[]>>(`${environment.apiUrl}/api/useradmin/GetAllAdminUsers`).pipe(mapResponse());
  }

  getUser(userId: string): Observable<UserAdminData> {
    return this.http.get<ServiceResponse<UserAdminData>>(`${environment.apiUrl}/api/useradmin/${userId}`).pipe(mapResponse());
  }

  getIdentityUser(userName: string): Observable<IdentityUserData> {
    return this.http
      .get<ServiceResponse<IdentityUserData>>(`${environment.apiUrl}/api/useradmin/GetIdentityUserForCreate/${userName}`)
      .pipe(mapResponse());
  }

  updateUser(user: UserAdminData): Observable<UserAdminData> {
    return this.http.put<ServiceResponse<UserAdminData>>(`${environment.apiUrl}/api/useradmin/${user.userId}`, user).pipe(mapResponse());
  }

  createUser(user: UserAdminData): Observable<UserAdminData> {
    return this.http.post<ServiceResponse<UserAdminData>>(`${environment.apiUrl}/api/useradmin/`, user).pipe(mapResponse());
  }

  getCarrierUsersData(carrierId: string): Observable<CarrierUsersData> {
    return this.http
      .get<ServiceResponse<CarrierUsersData>>(`${environment.apiUrl}/api/UserAdmin/GetCarrierUsersData/${carrierId}`)
      .pipe(mapResponse());
  }

  deleteUser(user: UserAdminData): Observable<UserAdminData> {
    return this.http.delete<ServiceResponse<UserAdminData>>(`${environment.apiUrl}/api/useradmin/${user.userId}`).pipe(mapResponse());
  }
}
